export default "__VITE_ASSET__DJfpNoXF__"